import Fetch from '../Fetch';

export default {
  queryNetworksList: (params) => {
    return Fetch.get(`/api/v1/profile/list`, { params });
  },
  queryPortList: (params, config) => {
    const {loading} = config
    return Fetch.get(`/api/v1/swcfg_port`, { params, loading });
  },
  deletePortMode: (params) => {
    return Fetch.post(`/api/v1/port_mode_del`, params);
  },
  deleteNetworks: (params) => {
    return Fetch.delete(`/api/v1/vlan`, { params });
  },
  deleteProfile: (params) => {
    return Fetch.post(`/api/v1/profile/delete`, params);
  },
  updatePortInfo: (params) => {
    return Fetch.post(`/api/v1/swcfg_port`, params);
  },
  queryVlanInfoByVlanId: (params) => {
    return Fetch.get(`/api/v1/vlan`, { params });
  },
  addVlanInfo: (params) => {
    return Fetch.post(`/api/v1/vlan`, params);
  },
  addVlanInfoNew: (params) => {
    return Fetch.post(`/api/v1/profile/add`, params);
  },
  queryVlanIpInfoByVlanId: (params) => {
    return Fetch.get(`/api/v1/vlan_ip`, { params });
  },
  updateVlanIpInfo: (params) => {
    return Fetch.post(`/api/v1/vlan_ip`, params);
  },
  queryVlanDhcpInfoByVlanId: (params) => {
    return Fetch.get(`/api/v1/vlan_dhcp`, { params });
  },
  updateVlanDhcpInfo: (params) => {
    return Fetch.post(`/api/v1/vlan_dhcp`, params);
  },
  queryProfileTemplatesList: () => {
    return Fetch.get(`/api/v1/profile`);
  },
  addProfileTemplates: (params) => {
    return Fetch.post(`/api/v1/profile`, params);
  },
  updateProfileTemplates: (params) => {
    return Fetch.post(`/api/v1/profile_edit`, params);
  },
  deleteProfileTemplates: (params) => {
    return Fetch.post(`/api/v1/profile_del`, params);
  },
  autoTrunk: (params) => {
    return Fetch.post(`/api/v1/sw_auto_trunk_cfg`, params);
  },
  autoLag: (params) => {
    return Fetch.post(`/api/v1/sw_auto_lag_cfg`, params);
  },
  queryAutoTrunk: () => {
    return Fetch.get(`/api/v1/sw_auto_trunk_cfg`);
  },
  queryAutoLag: () => {
    return Fetch.get(`/api/v1/sw_auto_lag_cfg`);
  },
  updateShure: () => {
    return Fetch.post(`/api/v1/shure_restart`, {}, { loading: false });
  },
  deleteShure: () => {
    return Fetch.post(`/api/v1/shure_stop`);
  },
  queryPtpSwitchInfo: () => {
    return Fetch.get(`/api/v1/sw_ptp_cfg`);
  },
  updatePtpSwitchInfo: (params) => {
    return Fetch.post(`/api/v1/sw_ptp_cfg`, params);
  },
  updateQuerierInfo: (params) => {
    return Fetch.post(`/api/v1/snoop_querier`, params);
  },
  queryQuerierInfo: (params) => {
    return Fetch.get(`/api/v1/snoop_querier`, { params });
  },
  queryQtpInfo: (params) => {
    return Fetch.get(`/api/v1/linuxptp/ptp_bc_cfg`, { params });
  },
  updateQtpInfo: (params) => {
    return Fetch.post(`/api/v1/linuxptp/ptp_bc_cfg`, params);
  },
  updateHarmanInfo: (params) => {
    return Fetch.post(`/api/v1/profile/harman`, params);
  },
  updateVisionaryInfo: (params) => {
    return Fetch.post(`/api/v1/profile/visionary`, params);
  },
  updateManualTrunkInfo: (params) => {
    return Fetch.post(`/api/v1/sw_manual_trunk_cfg`, params);
  },
  queryManualTrunkInfo: (params) => {
    return Fetch.get(`/api/v1/sw_manual_trunk_cfg`, { params });
  },
  updateUnTrunkInfo: (params) => {
    return Fetch.post(`/api/v1/profile/port`, params);
  },
};
